import React, {useEffect} from 'react'
import {useParams, useSearchParams} from 'react-router-dom'
import questionsApi from '../../services/api/questionLibrary/questionsApi'
import SubmissionBlocker from './submissionBlocker'
import WelcomeScreen from './WelcomeScreen'
import Questions from './Questions'
import {getSurveyThemeStyle} from './surveyTheme'
import {CircularProgress} from '@mui/material'

export default function SurveyView() {
  const {aud, token} = useParams()
  const [surveyStart, setSurveyStart] = React.useState(false)
  const [surveyEnd, setSurveyEnd] = React.useState(false)
  const [surveyData, setSurveyData] = React.useState(null)
  const [loading, setLoading] = React.useState(true)

  useEffect(() => {
    questionsApi
      .getQuestionForParticipants(token)
      .then(res => setSurveyData(res))
      .finally(() => setLoading(false))
  }, [])

  const content = loading ? (
    <div className="welcome">
      <CircularProgress color="inherit" />
    </div>
  ) : surveyData?.isSurveyClosed ? (
    <SubmissionBlocker type="closed" />
  ) : surveyData?.isSubmitted ? (
    <SubmissionBlocker />
  ) : !surveyStart ? (
    <WelcomeScreen
      setSurveyStart={setSurveyStart}
      name={surveyData?.surveyName}
    />
  ) : surveyEnd ? (
    <SubmissionBlocker type="end" />
  ) : (
    <Questions
      questions={surveyData?.questions}
      tab={parseInt(aud)}
      setSurveyEnd={setSurveyEnd}
    />
  )

  // Apply the survey's custom theme (WI-409). getSurveyThemeStyle returns null for
  // surveys without a saved theme, so the default look is preserved unchanged.
  const themeStyle = getSurveyThemeStyle(surveyData?.surveyTheme)
  return themeStyle ? (
    <div className="survey-themed" style={themeStyle} data-testid="survey-themed">
      {content}
    </div>
  ) : (
    content
  )
}
